import { useMemo, useState } from "react";
import axios from "axios";
import { convertDateFormatInputDate } from "../util/formatsForDate";
// import SignatureModal from "../App/copmponents/SignatureModal";
import SignaturePad from "../components/ui/SignaturePad";
import { dataUrlToBlob } from "../util/signature";
import { urlToFile } from "../util/files";
import { validateIsraeliID } from "../util/validation";
// import logoTop from '../assets/ismb_logo.png'
import logonew from '../assets/logonew.png'
import MembershipPdfActions from "../components/ui/MembershipPdfActions";

import { createMembershipPdfSingle } from "../components/createMembershipPdfSingle";
const EMPTY_FORM = {
    idNumber: "",
    firstName: "",
    lastName: "",
    documentIndex: "",
    dateBorn: "",
    street: "",
    houseNumber: "",
    city: "",
    job: "", // "EMPLOYEE" | "SELF_EMPLOYED"
    employerName: "",
    workAddress: "",
    safetyEligibilityConfirmed: false,
    laborUnionStatus: "", // "NONE" | "STOPPED"
    allowNotifyOtherUnion: false,
    otherUnionName: "",
    imgFacePicture: null,      // File
    imagePreview: "",     // string (URL.createObjectURL)
    // ✅ חדש: חתימה
    signatureDataUrl: "", // "data:image/png;base64,..."
    signatureDate: new Date().toISOString().split("T")[0], // ✅ היום כברירת מחדל
    gender: "", // "MALE" | "FEMALE"
};

function validateIsraeliId(id) {
    // בדיקה בסיסית: 9 ספרות (בלי אלגוריתם checksum כדי לא להסתבך)
    return /^\d{9}$/.test(id);
}


export default function PublicDeclarationPage() {
    const [form, setForm] = useState(EMPTY_FORM);
    const [formEnabled, setFormEnabled] = useState(false);
    const [lookupLoading, setLookupLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [errors, setErrors] = useState({});
    const [globalError, setGlobalError] = useState("");
    const [infoMsg, setInfoMsg] = useState("");

    const isEmployee = form.job !== "עצמאי";
    const isSelfEmployed = form.job === "עצמאי";

    const disabled = useMemo(() => !formEnabled, [formEnabled]);

    const setField = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
        setErrors((prev) => ({ ...prev, [key]: "" }));
        setGlobalError("");
    };

    const runValidation = () => {
        const next = {};

        if (!validateIsraeliId(form.idNumber)) next.idNumber = "תעודת זהות חייבת להכיל 9 ספרות";
        if (!validateIsraeliID(form.idNumber)) next.idNumber = "תעודת זהות לא תקינה";
        if (!form.firstName?.trim()) next.firstName = "שדה חובה";
        if (!form.lastName?.trim()) next.lastName = "שדה חובה";
        // if (!form.number.trim()) next.number = "שדה חובה";
        if (!form.dateBorn) next.dateBorn = "שדה חובה";
        if (!form.documentIndex?.trim()) next.documentIndex = "שדה חובה";
        if (!form.houseNumber) next.houseNumber = "שדה חובה";
        if (!form.street?.trim()) next.street = "שדה חובה";
        if (!form.city?.trim()) next.city = "שדה חובה";
        if (!form.job) next.job = "בחר שכיר/עצמאי";
        if (!form.workAddress?.trim()) next.workAddress = "שדה חובה";
        if (form.laborUnionStatus === "STOPPED") {
            // if (!form.allowNotifyOtherUnion) {
            //     next.allowNotifyOtherUnion = "יש לאשר העברת הודעה לארגון האחר";
            // }
            if (!form.otherUnionName?.trim()) {
                next.otherUnionName = 'יש למלא שם ארגון אחר (או "אין")';
            }
        }
        if (!form.signatureDate) {
            next.signatureDate = "יש לבחור תאריך חתימה";
        }
        if (isEmployee && !form.employerName?.trim()) {
            next.employerName = "שם המעסיק הוא שדה חובה לשכיר";
        }
        if (isSelfEmployed && !form.employerName?.trim()) {
            next.employerName = "כתובת עצמאי היא שדה חובה לעצמאי";
        }

        if (!form.safetyEligibilityConfirmed) {
            next.safetyEligibilityConfirmed = "יש לאשר זכאות למינוי כממונה בטיחות";
        }

        if (!form.laborUnionStatus) {
            next.laborUnionStatus = "יש לבחור אחת מהאפשרויות";
        }
        if (!form.signatureDataUrl) {
            next.signatureDataUrl = "חובה לחתום";
        }
        if (!form.gender) {
            next.gender = "יש לבחור מין";
        }
        console.log(next)
        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const handleLookup = async () => {
        setGlobalError("");
        setInfoMsg("");
        setErrors({});

        if (!validateIsraeliId(form.idNumber)) {
            setErrors({ idNumber: "תעודת זהות חייבת להכיל 9 ספרות" });
            return;
        }

        if (!validateIsraeliID(form.idNumber)) {
            setErrors({ idNumber: "תעודת זהות לא תקינה" });
            return;
        }

        setLookupLoading(true);
        try {
            // ✅ התאמה לשרת: שנה את ה־URL לפי ה־API שלך
            // דוגמה: GET /public/declaration/member?identityNumber=123456789
            const res = await axios.get(`form/member_info?identityNumber=${form.idNumber}`);
            console.log(res)
            // נניח שהשרת מחזיר:
            // { exists: true/false, data: { firstName,lastName,number,dateBorn,number,houseNumber,city,job,employerName,workAddress } }
            const exists = !!res.data?.existDataBase;
            const data = res.data || {};

            if (exists) {
                let file1 = null;
                if (data?.imgFacePicture) {
                    file1 = await urlToFile(`https://archivebureau.s3.eu-west-3.amazonaws.com/${data?.imgFacePicture}?t=${Date.now()}`, data?.imgFacePicture?.split('/').pop());
                }
                setForm((prev) => ({
                    ...prev,
                    ...data,
                    imgFacePicture: file1 || "",
                    imagePreview: data?.imgFacePicture ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${data?.imgFacePicture}?t=${Date.now()}` : "",
                    // imgFacePicture: data.imgFacePicture || "",
                    employerName: data.job == "עצמאי" ? "עצמאי" : "",
                    job: data.job == "עצמאי" ? "עצמאי" : "שכיר",
                    idNumber: prev.idNumber, // לא נוגעים בת"ז
                }));
                setFormEnabled(true);
                setInfoMsg("נמצא במאגר ✅ הפרטים נטענו. אנא ודא שהכל נכון והשלם מה שחסר.");
            } else {
                setForm((prev) => ({
                    ...prev,
                    ...data,
                    idNumber: prev.idNumber, // לא נוגעים בת"ז
                }));
                // לא נמצא → מאפשרים מילוי ידני
                setFormEnabled(true);
                setInfoMsg("לא נמצא במאגר. ניתן למלא את הפרטים ידנית ולהגיש.");
            }
        } catch (e) {
            console.log(e)
            setGlobalError(e.response?.data?.message || "שגיאה בבדיקת תעודת זהות. נסה שוב.");
            setFormEnabled(false);
        } finally {
            setLookupLoading(false);
        }
    };
    const handleImageChange = (file) => {
        if (!file) return;

        // ולידציה בסיסית: רק תמונה
        if (!file.type.startsWith("image/")) {
            setErrors((prev) => ({ ...prev, imgFacePicture: "אפשר להעלות רק קובץ תמונה" }));
            return;
        }

        // עדיף גם להגביל גודל (לדוגמה 5MB)
        const maxSizeMb = 5;
        if (file.size > maxSizeMb * 1024 * 1024) {
            setErrors((prev) => ({ ...prev, imgFacePicture: `הקובץ גדול מדי (מקסימום ${maxSizeMb}MB)` }));
            return;
        }

        // ניקוי preview קודם כדי למנוע דליפת זיכרון
        if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);

        const previewUrl = URL.createObjectURL(file);

        setForm((prev) => ({
            ...prev,
            imgFacePicture: file,
            imagePreview: previewUrl,
        }));

        setErrors((prev) => ({ ...prev, imgFacePicture: "" }));
    };
    // const handleSubmit = async () => {
    //     setGlobalError("");
    //     setInfoMsg("");

    //     const ok = runValidation();
    //     if (!ok) return;

    //     setSubmitLoading(true);
    //     try {
    //         // ✅ התאמה לשרת: POST לרישום/עדכון
    //         // דוגמה: POST /public/declaration/submit
    //         await axios.post("/public/declaration/submit", form);

    //         setInfoMsg("הטופס נשלח בהצלחה ✅");
    //         // אם תרצה: לאפס/לנעול שוב
    //         // setForm(EMPTY_FORM); setFormEnabled(false);
    //     } catch (e) {
    //         setGlobalError("שגיאה בשליחת הטופס. נסה שוב.");
    //     } finally {
    //         setSubmitLoading(false);
    //     }
    // };
    const handleSubmit = async () => {
        setGlobalError("");
        setInfoMsg("");
        console.log("start");
        const ok = runValidation();
        console.log(ok)
        console.log("end")
        if (!ok) return;

        setSubmitLoading(true);
        try {
            const fd = new FormData();

            // מומלץ לא לשלוח imagePreview/signatureDataUrl בתוך payload
            const { imagePreview, imgFacePicture, signatureDataUrl, ...payload } = form;
            const pdfData={
                "memberId": form.id || 0,
                "fillFirstName": form.firstName,
                "fillLastName": form.lastName,
                "identityNumber": form.idNumber,
                "dataBorn": form.dateBorn,
                "gender": form.gender,
                "street": `${form.street} ${form.houseNumber}`,
                "city": form.city,
                "job": form.job,
                "employerName": form.employerName,
                "placeJob": form.workAddress,
                "box1": form.safetyEligibilityConfirmed,
                "box2": !(form.laborUnionStatus === "STOPPED"),
                "box3": form.laborUnionStatus === "STOPPED",
                "otherOrganizationName": form.otherUnionName,
                // "fullDate": "2025-03-23 15:30",
                "fullDate": `${form.signatureDate} 00:00`,
                "documentIndex": form.documentIndex
            };
            // fd.append("document_details", new Blob([JSON.stringify(payload)], { type: "application/json" }));
            fd.append("document_details", JSON.stringify(pdfData));

            // image
            // fd.append("selfImageFile", imgFacePicture||imagePreview? await urlToFile(`${imagePreview}?t=${Date.now()}`) : "");
            fd.append("selfImageFile", imgFacePicture);

            // signature
            const sigBlob = dataUrlToBlob(signatureDataUrl);
            fd.append("signatureImageFile", new File([sigBlob], "signature.png", { type: "image/png" }));
          
            const pdf = await createMembershipPdfSingle({...pdfData,"selfImage_url":imagePreview,"signatureImage_url":signatureDataUrl});
            const pdfBlob = pdf.output('blob');
            fd.append('documentSummaryFile', pdfBlob, `${form.firstName}_${form.lastName}.pdf`);
            await axios.post("form/member_document", fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            // setInfoMsg("הטופס נשלח בהצלחה ✅");
            alert("הטופס נשלח בהצלחה ✅");
            setForm(EMPTY_FORM); setFormEnabled(false);
        } catch (e) {
            setGlobalError("שגיאה בשליחת הטופס. נסה שוב.");
        } finally {
            setSubmitLoading(false);
        }
    };
    return (
        <div className="min-h-screen bg-slate-50 py-8 px-4" dir="rtl">
            <div className="max-w-3xl mx-auto">

                <div className="bg-white shadow-sm rounded-2xl border border-slate-200 p-6">
                    <div className="w-full flex items-center  ">

                        <h1 className="sm:text-2xl text-sm font-semibold px-2 rounded-lg font-serif text-white w-full whitespace-pre-line  bg-purple-700 text-center">טופס הצטרפות כחבר/ה
                            <br />
                            ללשכת הממונים על הבטיחות בישראל
                            <br />
                            כארגון היציג של הממונים על הבטיחות בישראל
                        </h1>
                        <img src={logonew} alt="ISM Bureau Logo" className="sm:h-24 h-16  mx-2  " />
                    </div>
                    <div className="mt-6 rounded-2xl border text-right border-slate-200 bg-slate-50 p-5 leading-relaxed">
                        <p className="text-sm text-slate-800">
                            אני מצהיר/ה בזאת שברצוני להצטרף כחבר/ה ללשכת הממונים על הבטיחות בישראל (להלן:{" "}
                            <span className="font-semibold">"הלשכה"</span>) שמטרותיה מפורטות להלן.
                        </p>

                        <p className="text-sm text-slate-800 mt-3">
                            אני מתחייב/ת לציית להוראות תקנון הלשכה ולהחלטות המתקבלות מעת לעת על ידי מוסדותיה המוסמכים.
                        </p>

                        <p className="text-sm text-slate-800 mt-3">
                            אני מודע/ת לכך שהחברות בלשכה כרוכה בתשלום דמי חבר שנתיים, בסכום, במועד ובתנאים שייקבעו על ידי מוסדותיה המוסמכים של
                            הלשכה מעת לעת.
                        </p>

                        <p className="text-sm font-semibold text-slate-900 mt-4">ידוע לי שמטרות הלשכה הן:</p>

                        <ol className="mt-2 list-decimal pr-5 space-y-2 text-sm text-slate-800">
                            <li>להיות ארגון העובדים היציג של הממונים על הבטיחות בישראל.</li>
                            <li>
                                לפעול לשיפור תנאי העסקתם ושכרם של הממונים על הבטיחות בישראל באמצעות משא ומתן קיבוצי וחתימה על הסכם קיבוצי.
                            </li>
                            <li>
                                לפעול למען רווחתם ושיפור מעמדם של הממונים על הבטיחות בישראל, באמצעות קידום חקיקה ורגולציה, ניהול מאבקים ציבוריים
                                ו/או משפטיים, ו/או בכל דרך אחרת, על פי כל דין.
                            </li>
                        </ol>
                    </div>
                    <p className="text-sm text-slate-600 text-center mt-2">
                        הזן תעודת זהות כדי לטעון פרטים מהמאגר. לאחר מכן מלא/ודא את כל השדות ושלח.
                    </p>

                    {(globalError || infoMsg) && (
                        <div className="mt-4">
                            {globalError && (
                                <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">
                                    {globalError}
                                </div>
                            )}
                            {infoMsg && (
                                <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm rounded-xl p-3">
                                    {infoMsg}
                                </div>
                            )}
                        </div>
                    )}

                    {/* ת"ז + בדיקה */}
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
                        <div className="md:col-span-2">
                            <label className="block text-sm font-semibold text-slate-700 mb-1">תעודת זהות</label>
                            {errors.idNumber && <p className="text-red-600 text-xs mt-1">{errors.idNumber}</p>}
                            <input
                                // disabled={infoMsg == "נמצא במאגר ✅ הפרטים נטענו. אנא ודא שהכל נכון והשלם מה שחסר."}
                                disabled={infoMsg}
                                value={form.idNumber}
                                onChange={(e) => setField("idNumber", e.target.value.replace(/\D/g, "").slice(0, 9))}
                                placeholder="הזן 9 ספרות"
                                className={`w-full border rounded-xl p-3 text-right focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors.idNumber ? "border-red-300" : "border-slate-300"
                                    }`}
                            />

                        </div>

                        <button
                            type="button"
                            onClick={handleLookup}
                            // disabled={lookupLoading || infoMsg == "נמצא במאגר ✅ הפרטים נטענו. אנא ודא שהכל נכון והשלם מה שחסר."}
                            disabled={lookupLoading || infoMsg}
                            className="w-full md:w-auto bg-blue-600 text-white rounded-xl px-5 py-3 font-semibold hover:bg-blue-700 transition disabled:bg-slate-300 flex items-center justify-center gap-2"
                        >
                            {lookupLoading ? (
                                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            ) : null}
                            בדוק
                        </button>
                    </div>

                    {/* פרטי הממונה */}
                    <div className="mt-8">
                        <h2 className="text-lg font-bold text-slate-800 mb-4">פרטי הממונה</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Field label="שם פרטי" error={errors.firstName}>
                                <input
                                    disabled={disabled}
                                    value={form.firstName}
                                    onChange={(e) => setField("firstName", e.target.value)}
                                    className={inputClass(errors.firstName, disabled)}
                                />
                            </Field>

                            <Field label="שם משפחה" error={errors.lastName}>
                                <input
                                    disabled={disabled}
                                    value={form.lastName}
                                    onChange={(e) => setField("lastName", e.target.value)}
                                    className={inputClass(errors.lastName, disabled)}
                                />
                            </Field>

                            <Field label="מס' סידורי" error={errors.documentIndex}>
                                <input
                                    disabled={true}
                                    value={form.documentIndex}
                                    onChange={(e) => setField("documentIndex", e.target.value)}
                                    className={inputClass(errors.documentIndex, disabled)}
                                />
                            </Field>

                            <Field label="תאריך לידה" error={errors.dateBorn}>
                                <input
                                    disabled={disabled}
                                    type="date"
                                    value={form.dateBorn ? convertDateFormatInputDate(form.dateBorn) : ""}
                                    onChange={(e) => setField("dateBorn", e.target.value)}
                                    className={inputClass(errors.dateBorn, disabled)}
                                />
                            </Field>

                            <Field label="מין" error={errors.gender} full>
                                <div className={`flex gap-8 justify-center ${disabled ? "opacity-60" : ""}`}>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="gender"
                                            disabled={disabled}
                                            checked={form.gender === "זכר"}
                                            onChange={() => setField("gender", "זכר")}
                                        />
                                        <span>זכר</span>
                                    </label>

                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="gender"
                                            disabled={disabled}
                                            checked={form.gender === "נקבה"}
                                            onChange={() => setField("gender", "נקבה")}
                                        />
                                        <span>נקבה</span>
                                    </label>
                                </div>
                            </Field>

                            <Field label="עיר" error={errors.city}>
                                <input
                                    disabled={disabled}
                                    value={form.city}
                                    onChange={(e) => setField("city", e.target.value)}
                                    className={inputClass(errors.city, disabled)}
                                />
                            </Field>
                            <Field label="רחוב" error={errors.street} >
                                <input
                                    disabled={disabled}
                                    value={form.street}
                                    onChange={(e) => setField("street", e.target.value)}
                                    className={inputClass(errors.street, disabled)}
                                />
                            </Field>

                            <Field label="מספר בניין" error={errors.houseNumber}>
                                <input
                                    disabled={disabled}
                                    value={form.houseNumber}
                                    onChange={(e) => setField("houseNumber", e.target.value)}
                                    className={inputClass(errors.houseNumber, disabled)}
                                />
                            </Field>

                            <Field label="בחר את האפשרות הנכונה לגבייך" error={errors.job} full>
                                <div className={`flex gap-6 justify-center ${disabled ? "opacity-60" : ""}`}>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            disabled={disabled}
                                            type="radio"
                                            name="job"
                                            checked={form.job === "שכיר"}
                                            onChange={() => {
                                                setField("job", "שכיר")
                                                setField("employerName", "")
                                            }
                                            }
                                        />
                                        <span>שכיר</span>
                                    </label>

                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            disabled={disabled}
                                            type="radio"
                                            name="job"
                                            checked={form.job === "עצמאי"}
                                            onChange={() => {
                                                setField("job", "עצמאי")
                                                setField("employerName", "עצמאי")
                                            }
                                            }
                                        />
                                        <span>עצמאי</span>
                                    </label>
                                </div>
                            </Field>

                            <Field
                                // label={isEmployee ? "שם המעסיק" : "כתובת עצמאי"}
                                label={"שם המעסיק"}
                                error={errors.employerName}
                                full
                            >
                                <input
                                    disabled={disabled || !isEmployee}
                                    value={form.employerName}
                                    onChange={(e) => isEmployee && setField("employerName", e.target.value)}
                                    className={inputClass(errors.employerName, disabled)}
                                    placeholder={isEmployee ? "הזן שם מעסיק" : " עצמאי"}
                                />
                            </Field>

                            <Field label="כתובת מקום העבודה" error={errors.workAddress} full>
                                <input
                                    disabled={disabled}
                                    value={form.workAddress}
                                    onChange={(e) => setField("workAddress", e.target.value)}
                                    className={inputClass(errors.workAddress, disabled)}
                                />
                            </Field>
                            <div className="md:col-span-2 mt-6 border-t pt-5">

                                {/* 1. אישור זכאות */}
                                <div className="flex items-start gap-3">
                                    <input
                                        type="checkbox"
                                        disabled={disabled}
                                        checked={form.safetyEligibilityConfirmed}
                                        onChange={(e) =>
                                            setField("safetyEligibilityConfirmed", e.target.checked)
                                        }
                                        className="mt-1 w-4 h-4"
                                    />

                                    <p className="text-sm text-slate-800 leading-relaxed">
                                        אני מאשר/ת כי אני זכאי/ת להתמנות כממונה על בטיחות ומחזיק/ה באישור כשירות תקף לפי דין.
                                    </p>
                                </div>

                                {errors.safetyEligibilityConfirmed && (
                                    <p className="text-xs text-red-600 mt-1 mr-7">
                                        {errors.safetyEligibilityConfirmed}
                                    </p>
                                )}

                                {/* 2. סטטוס ארגון עובדים */}
                                <div className="mt-5">
                                    <p className="text-sm font-semibold text-slate-800 mb-2">
                                        בחר/י את האפשרות הנכונה לגבייך:
                                    </p>

                                    <div className={`flex flex-col gap-2 ${disabled ? "opacity-60" : ""}`}>
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="laborUnionStatus"
                                                disabled={disabled}
                                                checked={form.laborUnionStatus === "NONE"}
                                                onChange={() => setField("laborUnionStatus", "NONE")}
                                            />
                                            <span className="text-sm">
                                                אינני חבר/ה בארגון עובדים אחר
                                            </span>
                                        </label>

                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="laborUnionStatus"
                                                disabled={disabled}
                                                checked={form.laborUnionStatus === "STOPPED"}
                                                onChange={() => setField("laborUnionStatus", "STOPPED")}
                                            />
                                            <span className="text-sm">
                                                אני מודיע/ה בזאת על הפסקת חברותי בארגון אחר
                                            </span>
                                        </label>
                                    </div>

                                    {errors.laborUnionStatus && (
                                        <p className="text-xs text-red-600 mt-1">
                                            {errors.laborUnionStatus}
                                        </p>
                                    )}
                                    {form.laborUnionStatus === "STOPPED" && (
                                        <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4">

                                            <div className="flex items-start gap-3">
                                                {/* <input
        type="checkbox"
        disabled={disabled}
        checked={form.allowNotifyOtherUnion}
        onChange={(e) => setField("allowNotifyOtherUnion", e.target.checked)}
        className="mt-1 w-4 h-4"
      /> */}
                                                <p className="text-sm text-slate-800 leading-relaxed">
                                                    אני מאשר/ת ללשכת ממוני הבטיחות בישראל להעביר הודעה זו לארגון העובדים האחר לצורך ביטול החברות.
                                                </p>
                                            </div>

                                            {/* {errors.allowNotifyOtherUnion && (
      <p className="text-xs text-red-600 mt-1 mr-7">
        {errors.allowNotifyOtherUnion}
      </p>
    )} */}

                                            <div className="mt-4">
                                                <label className="block text-sm font-semibold text-slate-800 mb-1">
                                                    כתוב את שם הארגון האחר. "
                                                </label>

                                                <input
                                                    disabled={disabled}
                                                    value={form.otherUnionName}
                                                    onChange={(e) => setField("otherUnionName", e.target.value)}
                                                    className={`w-full border rounded-xl p-3 text-right focus:outline-none focus:ring-2 focus:ring-blue-500
          ${errors.otherUnionName ? "border-red-300" : "border-slate-300"}
          ${disabled ? "bg-slate-100 cursor-not-allowed" : "bg-white"}
        `}
                                                    placeholder='לדוגמה: "ההסתדרות"'
                                                />

                                                {errors.otherUnionName && (
                                                    <p className="text-xs text-red-600 mt-1">{errors.otherUnionName}</p>
                                                )}
                                            </div>

                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="md:col-span-2 mt-6 border-t pt-5">
                                <p className="text-sm font-semibold text-slate-800 mb-2">העלאת תמונה:</p>

                                <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
                                    {/* Upload box */}
                                    <div className="flex flex-col sm:flex-row gap-2 w-full md:w-72">
  {/* צלם עכשיו */}
  <label
    className={`w-full cursor-pointer rounded-xl border-2 border-dashed p-4 text-center transition
      ${disabled ? "bg-slate-100 border-slate-200 cursor-not-allowed" : "bg-white border-slate-300 hover:border-blue-400"}
      ${errors.imgFacePicture ? "border-red-300" : ""}
    `}
  >
    <input
      type="file"
      accept="image/*"
      capture="environment"
      disabled={disabled}
      className="hidden"
      onChange={(e) => handleImageChange(e.target.files?.[0])}
    />
    <div className="text-sm text-slate-700">צלם/י עכשיו</div>
    <div className="text-xs text-slate-500 mt-1">פתיחת מצלמה</div>
  </label>

  {/* בחר מהגלריה */}
  <label
    className={`w-full cursor-pointer rounded-xl border-2 border-dashed p-4 text-center transition
      ${disabled ? "bg-slate-100 border-slate-200 cursor-not-allowed" : "bg-white border-slate-300 hover:border-blue-400"}
      ${errors.imgFacePicture ? "border-red-300" : ""}
    `}
  >
    <input
      type="file"
      accept="image/*"
      disabled={disabled}
      className="hidden"
      onChange={(e) => handleImageChange(e.target.files?.[0])}
    />
    <div className="text-sm text-slate-700">בחר/י מהגלריה</div>
    <div className="text-xs text-slate-500 mt-1">PNG / JPG (עד 5MB)</div>
  </label>
</div>

                                    {/* Preview */}
                                    <div className="w-full md:flex-1">
                                        {form.imagePreview ? (
                                            <div className="rounded-xl overflow-hidden border border-slate-200 bg-white">
                                                <img
                                                    src={form.imagePreview}
                                                    alt="תצוגת תמונה"
                                                    className="w-full max-h-64 object-contain pt-2 bg-slate-50"
                                                />
                                                <div className="p-2 flex justify-center items-center">
                                                    {/* <span className="text-xs text-slate-600 truncate">
                                                        {form.imgFacePicture?.name}
                                                    </span> */}

                                                    <button
                                                        type="button"
                                                        disabled={disabled}
                                                        className="text-xs text-red-600 hover:underline disabled:opacity-50"
                                                        onClick={() => {
                                                            if (form.imagePreview) URL.revokeObjectURL(form.imagePreview);
                                                            setForm((prev) => ({ ...prev, imgFacePicture: null, imagePreview: "" }));
                                                            setErrors((prev) => ({ ...prev, imgFacePicture: "חובה להעלות תמונה" }));
                                                        }}
                                                    >
                                                        הסר
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="text-xs text-slate-500">
                                                לא נבחרה תמונה להצגה
                                            </div>
                                        )}

                                        {errors.imgFacePicture && (
                                            <p className="text-xs text-red-600 mt-2">{errors.imgFacePicture}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* <SignatureModal /> */}
                            <SignaturePad
                                value={form.signatureDataUrl}
                                onChange={(v) => setField("signatureDataUrl", v)}
                                disabled={disabled}
                                error={errors.signatureDataUrl}
                            />


                            {/* תאריך חתימה */}
                            <div className="md:col-span-2 mt-6">
                                <label className="block text-sm font-semibold text-slate-800 mb-1">
                                    תאריך חתימת המסמך
                                </label>

                                <input
                                    type="date"
                                    disabled={disabled}
                                    value={form.signatureDate}
                                    onChange={(e) => setField("signatureDate", e.target.value)}
                                    className={`w-full md:w-64 border rounded-xl p-3 text-right focus:outline-none focus:ring-2 focus:ring-blue-500
      ${errors.signatureDate ? "border-red-300" : "border-slate-300"}
      ${disabled ? "bg-slate-100 cursor-not-allowed" : "bg-white"}
    `}
                                />

                                {errors.signatureDate && (
                                    <p className="text-xs text-red-600 mt-1">{errors.signatureDate}</p>
                                )}
                            </div>
                        </div>

                        <div className="mt-6 flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={() => {
                                    setForm(EMPTY_FORM);
                                    setFormEnabled(false);
                                    setErrors({});
                                    setGlobalError("");
                                    setInfoMsg("");
                                }}
                                className="px-4 py-2 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-50"
                            >
                                איפוס
                            </button>

                            <button
                                type="button"
                                disabled={!formEnabled || submitLoading}
                                onClick={handleSubmit}
                                className="px-5 py-2 rounded-xl bg-emerald-600 text-white font-semibold hover:bg-emerald-700 transition disabled:bg-slate-300 flex items-center gap-2"
                            >
                                {submitLoading ? (
                                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                ) : null}
                                שלח הצהרה
                            </button>

                            {/* <button onClick={() => CreateMembershipPdf()}>
  הורד PDF
</button> */}
{/* <MembershipPdfActions/> */}
                        </div>
                    </div>
                </div>

                {/* <p className="text-xs text-slate-500 text-center mt-4">
                    דף ציבורי — אין צורך להתחברות.
                </p> */}
            </div>
        </div>
    );
}

function Field({ label, error, children, full }) {
    return (
        <div className={full ? "md:col-span-2" : ""}>
            <label className="block text-sm font-semibold text-slate-700 mb-1">{label}</label>
            {children}
            {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
        </div>
    );
}

function inputClass(hasError, disabled) {
    return `w-full border rounded-xl p-3 text-right focus:outline-none focus:ring-2 focus:ring-blue-500
  ${hasError ? "border-red-300" : "border-slate-300"}
  ${disabled ? "bg-slate-100 cursor-not-allowed" : "bg-white"}`;
}
